export default {
    form: {
        title: 'Set up your nickname:',
        placeholder: 'Enter your nickname',
        button: 'START PLAYING'
    },
    intro: {
        title: 'Season 1',
        subtitle: 'First Race'
    }
}



// WEBPACK FOOTER //
// src/lang/locales/en/presets.js